// extracted by mini-css-extract-plugin
export default {"addressAction":"X7-z","loading":"Y7-z"};